export default __webpack_public_path__ + "static/media/webBanner.7ef5d55e.png";